export const CHAT_DATA1 = {
  scenes: [
    {
      id: 0,
      messages: [
        {
          sender: 'astrid',
          text: "Commander, hear that wind? Takes me back to when I became Stormweaver."
        },
        {
          sender: 'astrid',
          text: "Ever wonder about that name or my time in the Frostpeak Mountains?"
        },
      ],
      choices: [
        {
          text: "Ask about the mountains",
          nextScene: 1
        },
        {
          text: "Ask about Stormweaver",
          nextScene: 2
        },
      ],
    },
    {
      id: 1,
      messages: [
        {
          sender: 'player',
          text: "Tell me about the mountains."
        },
        {
          sender: 'astrid',
          text: "They're harsh but peaceful. Master Stormweaver said the wind there carries ancient spirits."
        },
        {
          sender: 'astrid',
          text: "I was shy back then. That solitude taught me real strength."
        },
      ],
      choices: [
        {
          text: "Sounds like it shaped who you are.",
          exitScene: true
        },
      ],
    },
    {
      id: 2,
      messages: [
        {
          sender: 'player',
          text: "What's behind the Stormweaver name?"
        },
        {
          sender: 'astrid',
          text: "It's a title from my mentor—someone who guides others through life's storms."
        },
        {
          sender: 'astrid',
          text: "It's an honor, but it means carrying a big responsibility."
        },
      ],
      choices: [
        {
          text: "I appreciate you sharing this.",
          exitScene: true
        },
      ],
    },
  ],
  chatDisplayName: "xXx Fenrir Nightspire xXx",
  characterId: "fenrirNightspire",
  completion_reward: {
    premiumCurrency: 12
  }
};
